export default __webpack_public_path__ + "static/media/logo.9176288b.png";